document.addEventListener('DOMContentLoaded', () => {
    let party_type = document.querySelector('#cms_accident_party_party_type');

    if (party_type !== null) {
        function hide_inputs(inputs) {
            inputs.forEach(function (e) {
                e.classList.add('hidden');
            });
        }

        function show_inputs(inputs) {
            inputs.forEach(function (e) {
                e.classList.remove('hidden');
            });
        }

        function dynamic_fields_handler(party_type) {
            const vehicle_inputs = document.querySelectorAll('.party_type_vehicle_input');
            const person_inputs = document.querySelectorAll('.party_type_person_input');
            const property_inputs = document.querySelectorAll('.party_type_property_input');

            switch (party_type.value) {
                case 'vehicle':
                    show_inputs(vehicle_inputs);
                    hide_inputs(person_inputs);
                    hide_inputs(property_inputs);
                    break;

                case 'person':
                    hide_inputs(vehicle_inputs);
                    show_inputs(person_inputs);
                    hide_inputs(property_inputs);
                    break;

                case 'property':
                    hide_inputs(vehicle_inputs);
                    hide_inputs(person_inputs);
                    show_inputs(property_inputs);
                    break;

                default:
                    hide_inputs(vehicle_inputs);
                    hide_inputs(person_inputs);
                    hide_inputs(property_inputs);
                    return;
            }
        }

        dynamic_fields_handler(party_type);

        party_type.addEventListener("change", function () {
            dynamic_fields_handler(this);
        });
    }
});
